<h1 mat-dialog-title>Full Data</h1>
<div mat-dialog-content>
  <p>{{ data.content }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
